import { makeStyles } from "@material-ui/core/styles";
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import getSymbolFromCurrency from 'currency-symbol-map';
import { QPaymentsApi } from "eclipse-react-sdk/services";
import React, { useCallback, useState } from "react";
import { SpinnerComponent } from "react-element-spinner";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as SuccessTransactionIcon } from '../../assets/img/success_transfer_wallet.svg';
import { ReactComponent as FailedTransactionIcon } from '../../assets/img/transaction_failed.svg';
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import Button from "../../components/CustomButtons/Button.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { loginToApp } from "../../redux-services/actions/actions.js";
import { primaryColor, primaryIconColor } from "../../style.scss";

const useStyles = makeStyles(themeStyle);

const delay = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export function SuccessCardPayment(props) {
  const [qrPaymentData, setQRPaymentData] = useState(props?.appData?.qrPaymentData);
  const manifestSettings = props?.appData?.template?.manifestSettings
  const walletTitleText = props?.appData?.template?.pwaAppOptions?.walletTitleText;
  const [requestCount, setRequestCount] = useState(0);
  const history = useHistory();
  const classes = useStyles();
  const scannedQRData = props?.appData?.qrPaymentData?.scannedQRData;
  const paymentDetails = props?.appData?.qrPaymentData?.paymentDetails;
  const selectedWallet = props?.appData?.wallets?.filter(wallet => wallet?.walletId === paymentDetails.fromWalletCard)[0];
  const [isLoading, setLoading] = useState(true);
  const [alertData, setAlert] = useState(null);
  const [responseData,setresponseData] =useState(null);
  const [paymentTime,setPaymentTime] = useState(null);

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }, [history]);

  const handleButtonClick = () => {
    if (qrPaymentData?.status === 'SUCCESSFUL') {
      handleSucessSubmit();
    } else if (qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' && qrPaymentData?.status !== 'TIMEDOUT') 
    {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    const selectedCard = props?.appData?.qrPaymentData?.cardDetailData;
    
    props.successCardPaymentHandler({ ...props?.appData});
    const pathname = props?.appData?.qrPaymentData?.fromScreen 
    ? '/pages/payshap-qr' 
    : '/pages/pay-qr';
    
    history.push({
        pathname: pathname,
        state: {
          scannedQRData: scannedQRData,
          paymentDetails: paymentDetails,
          walletDetailData: selectedWallet,
          cardDetailData: selectedCard,
          paymentProcess: props?.appData?.qrPaymentData?.paymentProcess,
          fromScreen:pathname,
          shapID:props?.appData?.qrPaymentData?.shapID
        }
      }) 
    }
  
    const handleSucessSubmit =() =>
      {
        delete props?.appData?.fromScreen;
        delete props?.appData?.qrPaymentData;
        props.appData.isRefresh = true;
        props.successCardPaymentHandler({ ...props?.appData });
        history.push({
          pathname: '/pages/dashboard',
        });

      }
  
  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const getQRPaymentStatus = useCallback((qrPaymentData) => {
    if (requestCount > 89 || qrPaymentData?.status !== 'PENDING') {
      if (requestCount > 89) {
        const updatedQRPaymentData = {
          ...qrPaymentData,
          status: 'TIMEDOUT'
        }
        setQRPaymentData(updatedQRPaymentData);
      }
      setLoading(false);
      return;
    }
    if (requestCount < 90 && qrPaymentData && qrPaymentData?.paymentId && qrPaymentData?.status === 'PENDING') {
      setLoading(true)
      const walletCardPaymentAPI = new QPaymentsApi();
      walletCardPaymentAPI.tenantsTenantIdPaymentsPaymentIdGet(props?.appData?.auth?.tenantId, qrPaymentData?.paymentId).then(async (walletCardPaymentAPIResponse) => {
        setresponseData(walletCardPaymentAPIResponse.data)
        setPaymentTime(convertToLocalTime(responseData?.created))
        if (walletCardPaymentAPIResponse.data && walletCardPaymentAPIResponse.data?.paymentId && walletCardPaymentAPIResponse.data?.status) {
          if (walletCardPaymentAPIResponse.data?.status === 'PENDING') {
            await delay(3000);
            setRequestCount(requestCount + 1);
          } else {
            setQRPaymentData(walletCardPaymentAPIResponse.data);
          }
        } else {
          redirectToErrorScreen('/pages/dashboard', '/pages/error');
        }
      }).catch((error) => {
        setLoading(false);
        if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
          showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
        } else {
          redirectToErrorScreen('/pages/dashboard', '/pages/error');
        }
      });
    } else {
      redirectToErrorScreen('/pages/dashboard', '/pages/error');
    }
  }, [props, redirectToErrorScreen, requestCount,responseData]);

  const convertToLocalTime =(isoTimestamp)=> {
    if(!isoTimestamp){
      return null
    }
    const date = new Date(isoTimestamp);
    const localDateString = date.toLocaleString(); 
    return localDateString;
  }

  
    React.useEffect(() => {
      if (qrPaymentData?.status !== 'TIMEDOUT') {
        getQRPaymentStatus(qrPaymentData);
      }
    }, [getQRPaymentStatus,qrPaymentData]);
  
  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              {qrPaymentData?.status === 'SUCCESSFUL' ? <SuccessTransactionIcon fill={primaryIconColor} stroke={primaryIconColor} /> : null}
              {qrPaymentData?.status === 'PENDING' ? <HourglassEmptyIcon fill={primaryIconColor} stroke={primaryIconColor} /> : null}
              {qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' ? <FailedTransactionIcon stroke={primaryIconColor} /> : null}
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <h3 className={classes.textCenter + ' m-t-0'}>
                <b>
                  {qrPaymentData?.status === 'SUCCESSFUL' ? 'Payment successful!' : null}
                  {qrPaymentData?.status === 'PENDING' ? 'Please wait, we are processing...' : null}
                  {qrPaymentData?.status === 'TIMEDOUT' ? 'We are experiencing an issue while processing your payment. Please try again later.' : null}
                  {qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' && qrPaymentData?.status !== 'TIMEDOUT' ? 'Payment failed!' : null}<br></br>
                
                </b>
              </h3>
              {props?.appData?.qrPaymentData?.fromScreen ?<>
             
              {qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' && qrPaymentData?.status !== 'TIMEDOUT'  ?
              <div>
                {qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' && qrPaymentData?.status !== 'TIMEDOUT' ? 'Check your recipients detail' : null}
                 <h2 style={{ color: primaryIconColor, margin: '0' }} className={classes.textCenter}><b>{getSymbolFromCurrency(responseData?.currency)}{(+paymentDetails?.amount ).toFixed(2)}</b></h2>
                  <br></br>
                  <p className={classes.textCenter +' m-b-0 '}><b>To: {scannedQRData?.reference}</b></p>
                  <p className={classes.textCenter  + ' m-b-0 m-t-0 '}><b>{props?.appData?.qrPaymentData?.shapID?" ShapID: "+ props?.appData?.qrPaymentData?.shapID :null }</b></p>
                  <p className={classes.textCenter  + ' m-b-0 m-t-0 '}><b>{props?.appData?.qrPaymentData?.recipientBank?" Recipient’s bank: "+ props?.appData?.qrPaymentData?.recipientBank :null } </b></p>
                  <p className={classes.textCenter  + ' m-b-0 m-t-0 '}><b>from your wallet: {manifestSettings?.brand.toUpperCase()} {walletTitleText?.toLowerCase()}-{qrPaymentData?.fromWalletCard}</b></p>
                  <p className={classes.textCenter  + ' m-b-0 m-t-0 '}><b>{paymentTime}</b></p>
                </div>
                :null}
                </>:null}

              {qrPaymentData?.status === 'SUCCESSFUL' ?
                  <h3 style={{ color: primaryIconColor, margin: '0' }} className={classes.textCenter}><b>{getSymbolFromCurrency(responseData?.currency)}{(+paymentDetails?.amount ).toFixed(2)} </b> </h3>                   
                : null}

                { qrPaymentData?.httpStatus && qrPaymentData?.httpStatus !== 200? 
                <div>
                  <p className={classes.textCenter}>Your payment was unsuccessful. Please try again if the problem persists contact support.</p>
                </div>
                :null}
            </GridItem>
            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '40px' }}>
            {qrPaymentData?.status === 'PENDING' ? <></> :<>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="button" onClick={handleButtonClick}>
                {qrPaymentData?.status === 'SUCCESSFUL' ? 'Done' : null} 
                {qrPaymentData?.status !== 'SUCCESSFUL' ? 'Try again' : null}
              </Button>
              </>}
              {qrPaymentData?.httpStatus && qrPaymentData?.httpStatus !== 200? <>
              <Button className={classes.buttonRadius} size="lg" block color="transparent" type="button"  onClick={() => window.location.href = 'mailto:eftservices@eftcorp.com'}>
                Contact Support
              </Button>
              </>:null}
              {qrPaymentData?.status !== 'SUCCESSFUL' && qrPaymentData?.status !== 'PENDING' ?
              <p className={classes.textCenter}><span className={classes.linkColor} onClick={handleSucessSubmit}  >Cancel</span></p> :null}
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  successCardPaymentHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SuccessCardPayment)